export default "__VITE_ASSET__BqmO5fpQ__"